import { ADDITIONAL_INFORMATION_LIMIT } from './constants';

// Note: In future, we should change to `formik`.
export function isAdditionalInformationNotValid(answer: string) {
  return answer.length > ADDITIONAL_INFORMATION_LIMIT;
}
